import { useEffect, useState } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import { graphql, useFragment } from 'react-relay';
import { type usePdpSaleUrgencyBannerVariant_displayPrice$key } from './__generated__/usePdpSaleUrgencyBannerVariant_displayPrice.graphql';
import { PRICE_TYPES } from 'dibs-buyer-price/src/constants';

const TEST_NAME = 'PDP_SaleEnding_Aug2025';

const displayPriceFragment = graphql`
    fragment usePdpSaleUrgencyBannerVariant_displayPrice on ItemDisplayPriceType
    @relay(plural: true) {
        amountType
    }
`;

export const usePdpSaleUrgencyBannerVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(getAbTestV2(TEST_NAME)?.variant === 'variant');
    }, []);

    return isVariant;
};

export const useTrackPdpSaleUrgencyBannerVariant = (
    displayPriceRef?: usePdpSaleUrgencyBannerVariant_displayPrice$key | null
): void => {
    const displayPrice = useFragment(displayPriceFragment, displayPriceRef);
    const isOnSale = displayPrice?.[0]?.amountType === PRICE_TYPES.SALE;

    useEffect(() => {
        if (isOnSale) {
            trackAbTestV2Variant(TEST_NAME);
        }
    }, [isOnSale]);
};
